export default __webpack_public_path__ + "static/media/vpssita.0ecedc0c.pdf";